import { customAlphabet } from "nanoid";
/**
 * Note/folder/attachment IDs are generated CLIENT-SIDE because items must be
 * creatable offline. URL-safe, no ambiguous characters, 16 chars of
 * lowercase+digits ≈ 82 bits — collision-safe at any realistic note count.
 */
const alphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
export const newId = customAlphabet(alphabet, 16);
/** Longer token for server-side secrets (magic links). 128+ bits. */
export const newToken = customAlphabet(alphabet, 32);
//# sourceMappingURL=ids.js.map